{
    "004": {
        "areaCodes": null,
        "dialCode": "93",
        "flag": "af",
        "iso": "AF",
        "mask": "+93 ## ### ####",
        "name": "Afghanistan (‫افغانستان‬‎)",
        "placeholder": "+93 00 000 0000",
        "priority": 0
    },
    "008": {
        "areaCodes": null,
        "dialCode": "355",
        "flag": "al",
        "iso": "AL",
        "mask": "+355 ## ### ####",
        "name": "Albania (Shqipëri)",
        "placeholder": "+355 00 000 0000",
        "priority": 0
    },
    "012": {
        "areaCodes": null,
        "dialCode": "213",
        "flag": "dz",
        "iso": "DZ",
        "mask": "+213 ### ## ## ##",
        "name": "Algeria (‫الجزائر‬‎)",
        "placeholder": "+213 000 00 00 00",
        "priority": 0
    },
    "016": {
        "areaCodes": null,
        "dialCode": "1684",
        "flag": "as",
        "iso": "AS",
        "mask": "+1684 ### ####",
        "name": "American Samoa",
        "placeholder": "+1684 000 0000",
        "priority": 0
    },
    "020": {
        "areaCodes": null,
        "dialCode": "376",
        "flag": "ad",
        "iso": "AD",
        "mask": "+376 ### ###",
        "name": "Andorra",
        "placeholder": "+376 000 000",
        "priority": 0
    },
    "024": {
        "areaCodes": null,
        "dialCode": "244",
        "flag": "ao",
        "iso": "AO",
        "mask": "+244 ### ### ###",
        "name": "Angola",
        "placeholder": "+244 000 000 000",
        "priority": 0
    },
    "028": {
        "areaCodes": null,
        "dialCode": "1268",
        "flag": "ag",
        "iso": "AG",
        "mask": "+1268 ### ####",
        "name": "Antigua and Barbuda",
        "placeholder": "+1268 000 0000",
        "priority": 0
    },
    "031": {
        "areaCodes": null,
        "dialCode": "994",
        "flag": "az",
        "iso": "AZ",
        "mask": "+994 ## ### ## ##",
        "name": "Azerbaijan (Azərbaycan)",
        "placeholder": "+994 00 000 00 00",
        "priority": 0
    },
    "032": {
        "areaCodes": null,
        "dialCode": "54",
        "flag": "ar",
        "iso": "AR",
        "mask": "+54 # ## #### ####",
        "name": "Argentina",
        "placeholder": "+54 0 00 0000 0000",
        "priority": 0
    },
    "036": {
        "areaCodes": null,
        "dialCode": "61",
        "flag": "au",
        "iso": "AU",
        "mask": "+61 ### ### ###",
        "name": "Australia",
        "placeholder": "+61 000 000 000",
        "priority": 0
    },
    "040": {
        "areaCodes": null,
        "dialCode": "43",
        "flag": "at",
        "iso": "AT",
        "mask": "+43 ### ######",
        "name": "Austria (Österreich)",
        "placeholder": "+43 000 000000",
        "priority": 0
    },
    "044": {
        "areaCodes": null,
        "dialCode": "1242",
        "flag": "bs",
        "iso": "BS",
        "mask": "+1242 ### ####",
        "name": "Bahamas",
        "placeholder": "+1242 000 0000",
        "priority": 0
    },
    "048": {
        "areaCodes": null,
        "dialCode": "973",
        "flag": "bh",
        "iso": "BH",
        "mask": "+973 #### ####",
        "name": "Bahrain (‫البحرين‬‎)",
        "placeholder": "+973 0000 0000",
        "priority": 0
    },
    "050": {
        "areaCodes": null,
        "dialCode": "880",
        "flag": "bd",
        "iso": "BD",
        "mask": "+880 #### ######",
        "name": "Bangladesh (বাংলাদেশ)",
        "placeholder": "+880 0000 000000",
        "priority": 0
    },
    "051": {
        "areaCodes": null,
        "dialCode": "374",
        "flag": "am",
        "iso": "AM",
        "mask": "+374 ## ######",
        "name": "Armenia (Հայաստան)",
        "placeholder": "+374 00 000000",
        "priority": 0
    },
    "052": {
        "areaCodes": null,
        "dialCode": "1246",
        "flag": "bb",
        "iso": "BB",
        "mask": "+1246 ### ####",
        "name": "Barbados",
        "placeholder": "+1246 000 0000",
        "priority": 0
    },
    "056": {
        "areaCodes": null,
        "dialCode": "32",
        "flag": "be",
        "iso": "BE",
        "mask": "+32 ### ## ## ##",
        "name": "Belgium (België)",
        "placeholder": "+32 000 00 00 00",
        "priority": 0
    },
    "060": {
        "areaCodes": null,
        "dialCode": "1441",
        "flag": "bm",
        "iso": "BM",
        "mask": "+1441 ### ####",
        "name": "Bermuda",
        "placeholder": "+1441 000 0000",
        "priority": 0
    },
    "064": {
        "areaCodes": null,
        "dialCode": "975",
        "flag": "bt",
        "iso": "BT",
        "mask": "+975 ## ## ## ##",
        "name": "Bhutan (འབྲུག)",
        "placeholder": "+975 00 00 00 00",
        "priority": 0
    },
    "068": {
        "areaCodes": null,
        "dialCode": "591",
        "flag": "bo",
        "iso": "BO",
        "mask": "+591 ########",
        "name": "Bolivia",
        "placeholder": "+591 00000000",
        "priority": 0
    },
    "072": {
        "areaCodes": null,
        "dialCode": "267",
        "flag": "bw",
        "iso": "BW",
        "mask": "+267 ## ### ###",
        "name": "Botswana",
        "placeholder": "+267 00 000 000",
        "priority": 0
    },
    "076": {
        "areaCodes": null,
        "dialCode": "55",
        "flag": "br",
        "iso": "BR",
        "mask": "+55 ## ##### ####",
        "name": "Brazil (Brasil)",
        "placeholder": "+55 00 00000 0000",
        "priority": 0
    },
    "080": {
        "areaCodes": null,
        "dialCode": "291",
        "flag": "er",
        "iso": "ER",
        "mask": "+291 # ### ###",
        "name": "Eritrea",
        "placeholder": "+291 0 000 000",
        "priority": 0
    },
    "084": {
        "areaCodes": null,
        "dialCode": "501",
        "flag": "bz",
        "iso": "BZ",
        "mask": "+501 ### ####",
        "name": "Belize",
        "placeholder": "+501 000 0000",
        "priority": 0
    },
    "086": {
        "areaCodes": null,
        "dialCode": "246",
        "flag": "io",
        "iso": "IO",
        "mask": "+246 ### ####",
        "name": "British Indian Ocean Territory",
        "placeholder": "+246 000 0000",
        "priority": 0
    },
    "090": {
        "areaCodes": null,
        "dialCode": "677",
        "flag": "sb",
        "iso": "SB",
        "mask": "+677 ## #####",
        "name": "Solomon Islands",
        "placeholder": "+677 00 00000",
        "priority": 0
    },
    "092": {
        "areaCodes": null,
        "dialCode": "1284",
        "flag": "vg",
        "iso": "VG",
        "mask": "+1284 ### ####",
        "name": "British Virgin Islands",
        "placeholder": "+1284 000 0000",
        "priority": 0
    },
    "096": {
        "areaCodes": null,
        "dialCode": "673",
        "flag": "bn",
        "iso": "BN",
        "mask": "+673 ### ####",
        "name": "Brunei",
        "placeholder": "+673 000 0000",
        "priority": 0
    },
    "100": {
        "areaCodes": null,
        "dialCode": "359",
        "flag": "bg",
        "iso": "BG",
        "mask": "+359 ## ### ###",
        "name": "Bulgaria (България)",
        "placeholder": "+359 00 000 000",
        "priority": 0
    },
    "104": {
        "areaCodes": null,
        "dialCode": "95",
        "flag": "mm",
        "iso": "MM",
        "mask": "+95 # ### ####",
        "name": "Myanmar (Burma) (မြန်မာ)",
        "placeholder": "+95 0 000 0000",
        "priority": 0
    },
    "108": {
        "areaCodes": null,
        "dialCode": "257",
        "flag": "bi",
        "iso": "BI",
        "mask": "+257 ## ## ## ##",
        "name": "Burundi (Uburundi)",
        "placeholder": "+257 00 00 00 00",
        "priority": 0
    },
    "112": {
        "areaCodes": null,
        "dialCode": "375",
        "flag": "by",
        "iso": "BY",
        "mask": "+375 ## ### ## ##",
        "name": "Belarus (Беларусь)",
        "placeholder": "+375 00 000 00 00",
        "priority": 0
    },
    "116": {
        "areaCodes": null,
        "dialCode": "855",
        "flag": "kh",
        "iso": "KH",
        "mask": "+855 ## ### ###",
        "name": "Cambodia (កម្ពុជា)",
        "placeholder": "+855 00 000 000",
        "priority": 0
    },
    "120": {
        "areaCodes": null,
        "dialCode": "237",
        "flag": "cm",
        "iso": "CM",
        "mask": "+237 # ## ## ## ##",
        "name": "Cameroon (Cameroun)",
        "placeholder": "+237 0 00 00 00 00",
        "priority": 0
    },
    "124": {
        "areaCodes": [
            "204",
            "226",
            "236",
            "249",
            "250",
            "289",
            "306",
            "343",
            "365",
            "387",
            "403",
            "416",
            "418",
            "431",
            "437",
            "438",
            "450",
            "506",
            "514",
            "519",
            "548",
            "579",
            "581",
            "587",
            "604",
            "613",
            "639",
            "647",
            "672",
            "705",
            "709",
            "742",
            "778",
            "780",
            "782",
            "807",
            "819",
            "825",
            "867",
            "873",
            "902",
            "905"
        ],
        "dialCode": "1",
        "flag": "ca",
        "iso": "CA",
        "mask": "+1 ### ### ####",
        "name": "Canada",
        "placeholder": "+1 000 000 0000",
        "priority": 1
    },
    "132": {
        "areaCodes": null,
        "dialCode": "238",
        "flag": "cv",
        "iso": "CV",
        "mask": "+238 ### ## ##",
        "name": "Cape Verde (Kabu Verdi)",
        "placeholder": "+238 000 00 00",
        "priority": 0
    },
    "136": {
        "areaCodes": null,
        "dialCode": "1345",
        "flag": "ky",
        "iso": "KY",
        "mask": "+1345 ### ####",
        "name": "Cayman Islands",
        "placeholder": "+1345 000 0000",
        "priority": 0
    },
    "140": {
        "areaCodes": null,
        "dialCode": "236",
        "flag": "cf",
        "iso": "CF",
        "mask": "+236 ## ## ## ##",
        "name": "Central African Republic (République centrafricaine)",
        "placeholder": "+236 00 00 00 00",
        "priority": 0
    },
    "144": {
        "areaCodes": null,
        "dialCode": "94",
        "flag": "lk",
        "iso": "LK",
        "mask": "+94 ## ### ####",
        "name": "Sri Lanka (ශ්‍රී ලංකාව)",
        "placeholder": "+94 00 000 0000",
        "priority": 0
    },
    "148": {
        "areaCodes": null,
        "dialCode": "235",
        "flag": "td",
        "iso": "TD",
        "mask": "+235 ## ## ## ##",
        "name": "Chad (Tchad)",
        "placeholder": "+235 00 00 00 00",
        "priority": 0
    },
    "152": {
        "areaCodes": null,
        "dialCode": "56",
        "flag": "cl",
        "iso": "CL",
        "mask": "+56 # #### ####",
        "name": "Chile",
        "placeholder": "+56 0 0000 0000",
        "priority": 0
    },
    "156": {
        "areaCodes": null,
        "dialCode": "86",
        "flag": "cn",
        "iso": "CN",
        "mask": "+86 ### #### ####",
        "name": "China (中国)",
        "placeholder": "+86 000 0000 0000",
        "priority": 0
    },
    "162": {
        "areaCodes": null,
        "dialCode": "61",
        "flag": "cx",
        "iso": "CX",
        "mask": "+61 ### ### ###",
        "name": "Christmas Island",
        "placeholder": "+61 000 000 000",
        "priority": 2
    },
    "166": {
        "areaCodes": null,
        "dialCode": "61",
        "flag": "cc",
        "iso": "CC",
        "mask": "+61 ### ### ###",
        "name": "Cocos (Keeling) Islands",
        "placeholder": "+61 000 000 000",
        "priority": 1
    },
    "170": {
        "areaCodes": null,
        "dialCode": "57",
        "flag": "co",
        "iso": "CO",
        "mask": "+57 ### #######",
        "name": "Colombia",
        "placeholder": "+57 000 0000000",
        "priority": 0
    },
    "174": {
        "areaCodes": null,
        "dialCode": "269",
        "flag": "km",
        "iso": "KM",
        "mask": "+269 ### ## ##",
        "name": "Comoros (‫جزر القمر‬‎)",
        "placeholder": "+269 000 00 00",
        "priority": 0
    },
    "175": {
        "areaCodes": null,
        "dialCode": "262",
        "flag": "yt",
        "iso": "YT",
        "mask": "+262 ### ## ## ##",
        "name": "Mayotte",
        "placeholder": "+262 000 00 00 00",
        "priority": 1
    },
    "178": {
        "areaCodes": null,
        "dialCode": "242",
        "flag": "cg",
        "iso": "CG",
        "mask": "+242 ## ### ####",
        "name": "Congo (Republic) (Congo-Brazzaville)",
        "placeholder": "+242 00 000 0000",
        "priority": 0
    },
    "180": {
        "areaCodes": null,
        "dialCode": "243",
        "flag": "cd",
        "iso": "CD",
        "mask": "+243 ### ### ###",
        "name": "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
        "placeholder": "+243 000 000 000",
        "priority": 0
    },
    "184": {
        "areaCodes": null,
        "dialCode": "682",
        "flag": "ck",
        "iso": "CK",
        "mask": "+682 ## ###",
        "name": "Cook Islands",
        "placeholder": "+682 00 000",
        "priority": 0
    },
    "188": {
        "areaCodes": null,
        "dialCode": "506",
        "flag": "cr",
        "iso": "CR",
        "mask": "+506 #### ####",
        "name": "Costa Rica",
        "placeholder": "+506 0000 0000",
        "priority": 0
    },
    "191": {
        "areaCodes": null,
        "dialCode": "385",
        "flag": "hr",
        "iso": "HR",
        "mask": "+385 ## ### ####",
        "name": "Croatia (Hrvatska)",
        "placeholder": "+385 00 000 0000",
        "priority": 0
    },
    "192": {
        "areaCodes": null,
        "dialCode": "53",
        "flag": "cu",
        "iso": "CU",
        "mask": "+53 # #######",
        "name": "Cuba",
        "placeholder": "+53 0 0000000",
        "priority": 0
    },
    "196": {
        "areaCodes": null,
        "dialCode": "357",
        "flag": "cy",
        "iso": "CY",
        "mask": "+357 ## ######",
        "name": "Cyprus (Κύπρος)",
        "placeholder": "+357 00 000000",
        "priority": 0
    },
    "200": {
        "areaCodes": null,
        "dialCode": "420",
        "flag": "cz",
        "iso": "CZ",
        "mask": "+420 ### ### ###",
        "name": "Czech Republic (Česká republika)",
        "placeholder": "+420 000 000 000",
        "priority": 0
    },
    "204": {
        "areaCodes": null,
        "dialCode": "229",
        "flag": "bj",
        "iso": "BJ",
        "mask": "+229 ## ## ## ##",
        "name": "Benin (Bénin)",
        "placeholder": "+229 00 00 00 00",
        "priority": 0
    },
    "208": {
        "areaCodes": null,
        "dialCode": "45",
        "flag": "dk",
        "iso": "DK",
        "mask": "+45 ## ## ## ##",
        "name": "Denmark (Danmark)",
        "placeholder": "+45 00 00 00 00",
        "priority": 0
    },
    "212": {
        "areaCodes": null,
        "dialCode": "1767",
        "flag": "dm",
        "iso": "DM",
        "mask": "+1767 ### ####",
        "name": "Dominica",
        "placeholder": "+1767 000 0000",
        "priority": 0
    },
    "214": {
        "areaCodes": [
            "809",
            "829",
            "849"
        ],
        "dialCode": "1",
        "flag": "do",
        "iso": "DO",
        "mask": "+1 ### ### ####",
        "name": "Dominican Republic (República Dominicana)",
        "placeholder": "+1 000 000 0000",
        "priority": 2
    },
    "218": {
        "areaCodes": null,
        "dialCode": "593",
        "flag": "ec",
        "iso": "EC",
        "mask": "+593 ## ### ####",
        "name": "Ecuador",
        "placeholder": "+593 00 000 0000",
        "priority": 0
    },
    "222": {
        "areaCodes": null,
        "dialCode": "503",
        "flag": "sv",
        "iso": "SV",
        "mask": "+503 #### ####",
        "name": "El Salvador",
        "placeholder": "+503 0000 0000",
        "priority": 0
    },
    "226": {
        "areaCodes": null,
        "dialCode": "240",
        "flag": "gq",
        "iso": "GQ",
        "mask": "+240 ### ### ###",
        "name": "Equatorial Guinea (Guinea Ecuatorial)",
        "placeholder": "+240 000 000 000",
        "priority": 0
    },
    "230": {
        "areaCodes": null,
        "dialCode": "251",
        "flag": "et",
        "iso": "ET",
        "mask": "+251 ## ### ####",
        "name": "Ethiopia",
        "placeholder": "+251 00 000 0000",
        "priority": 0
    },
    "233": {
        "areaCodes": null,
        "dialCode": "372",
        "flag": "ee",
        "iso": "EE",
        "mask": "+372 #### ####",
        "name": "Estonia (Eesti)",
        "placeholder": "+372 0000 0000",
        "priority": 0
    },
    "234": {
        "areaCodes": null,
        "dialCode": "298",
        "flag": "fo",
        "iso": "FO",
        "mask": "+298 ######",
        "name": "Faroe Islands (Føroyar)",
        "placeholder": "+298 000000",
        "priority": 0
    },
    "238": {
        "areaCodes": null,
        "dialCode": "500",
        "flag": "fk",
        "iso": "FK",
        "mask": "+500 #####",
        "name": "Falkland Islands (Islas Malvinas)",
        "placeholder": "+500 00000",
        "priority": 0
    },
    "242": {
        "areaCodes": null,
        "dialCode": "679",
        "flag": "fj",
        "iso": "FJ",
        "mask": "+679 ### ####",
        "name": "Fiji",
        "placeholder": "+679 000 0000",
        "priority": 0
    },
    "246": {
        "areaCodes": null,
        "dialCode": "358",
        "flag": "fi",
        "iso": "FI",
        "mask": "+358 ## #######",
        "name": "Finland (Suomi)",
        "placeholder": "+358 00 0000000",
        "priority": 0
    },
    "250": {
        "areaCodes": null,
        "dialCode": "33",
        "flag": "fr",
        "iso": "FR",
        "mask": "+33 # ## ## ## ##",
        "name": "France",
        "placeholder": "+33 0 00 00 00 00",
        "priority": 0
    },
    "254": {
        "areaCodes": null,
        "dialCode": "594",
        "flag": "gf",
        "iso": "GF",
        "mask": "+594 ### ## ## ##",
        "name": "French Guiana (Guyane française)",
        "placeholder": "+594 000 00 00 00",
        "priority": 0
    },
    "258": {
        "areaCodes": null,
        "dialCode": "689",
        "flag": "pf",
        "iso": "PF",
        "mask": "+689 ## ## ## ##",
        "name": "French Polynesia (Polynésie française)",
        "placeholder": "+689 00 00 00 00",
        "priority": 0
    },
    "262": {
        "areaCodes": null,
        "dialCode": "253",
        "flag": "dj",
        "iso": "DJ",
        "mask": "+253 ## ## ## ##",
        "name": "Djibouti",
        "placeholder": "+253 00 00 00 00",
        "priority": 0
    },
    "266": {
        "areaCodes": null,
        "dialCode": "241",
        "flag": "ga",
        "iso": "GA",
        "mask": "+241 ## ## ## ##",
        "name": "Gabon",
        "placeholder": "+241 00 00 00 00",
        "priority": 0
    },
    "268": {
        "areaCodes": null,
        "dialCode": "995",
        "flag": "ge",
        "iso": "GE",
        "mask": "+995 ### ## ## ##",
        "name": "Georgia (საქართველო)",
        "placeholder": "+995 000 00 00 00",
        "priority": 0
    },
    "270": {
        "areaCodes": null,
        "dialCode": "220",
        "flag": "gm",
        "iso": "GM",
        "mask": "+220 ### ####",
        "name": "Gambia",
        "placeholder": "+220 000 0000",
        "priority": 0
    },
    "280": {
        "areaCodes": null,
        "dialCode": "49",
        "flag": "de",
        "iso": "DE",
        "mask": "+49 #### #######",
        "name": "Germany (Deutschland)",
        "placeholder": "+49 0000 0000000",
        "priority": 0
    },
    "288": {
        "areaCodes": null,
        "dialCode": "233",
        "flag": "gh",
        "iso": "GH",
        "mask": "+233 ## ### ####",
        "name": "Ghana (Gaana)",
        "placeholder": "+233 00 000 0000",
        "priority": 0
    },
    "292": {
        "areaCodes": null,
        "dialCode": "350",
        "flag": "gi",
        "iso": "GI",
        "mask": "+350 ########",
        "name": "Gibraltar",
        "placeholder": "+350 00000000",
        "priority": 0
    },
    "296": {
        "areaCodes": null,
        "dialCode": "686",
        "flag": "ki",
        "iso": "KI",
        "mask": "+686 ########",
        "name": "Kiribati",
        "placeholder": "+686 00000000",
        "priority": 0
    },
    "300": {
        "areaCodes": null,
        "dialCode": "30",
        "flag": "gr",
        "iso": "GR",
        "mask": "+30 ### ### ####",
        "name": "Greece (Ελλάδα)",
        "placeholder": "+30 000 000 0000",
        "priority": 0
    },
    "304": {
        "areaCodes": null,
        "dialCode": "299",
        "flag": "gl",
        "iso": "GL",
        "mask": "+299 ## ## ##",
        "name": "Greenland (Kalaallit Nunaat)",
        "placeholder": "+299 00 00 00",
        "priority": 0
    },
    "308": {
        "areaCodes": null,
        "dialCode": "1473",
        "flag": "gd",
        "iso": "GD",
        "mask": "+1473 ### ####",
        "name": "Grenada",
        "placeholder": "+1473 000 0000",
        "priority": 0
    },
    "312": {
        "areaCodes": null,
        "dialCode": "590",
        "flag": "gp",
        "iso": "GP",
        "mask": "+590 ### ## ## ##",
        "name": "Guadeloupe",
        "placeholder": "+590 000 00 00 00",
        "priority": 0
    },
    "316": {
        "areaCodes": null,
        "dialCode": "1671",
        "flag": "gu",
        "iso": "GU",
        "mask": "+1671 ### ####",
        "name": "Guam",
        "placeholder": "+1671 000 0000",
        "priority": 0
    },
    "320": {
        "areaCodes": null,
        "dialCode": "502",
        "flag": "gt",
        "iso": "GT",
        "mask": "+502 #### ####",
        "name": "Guatemala",
        "placeholder": "+502 0000 0000",
        "priority": 0
    },
    "324": {
        "areaCodes": null,
        "dialCode": "224",
        "flag": "gn",
        "iso": "GN",
        "mask": "+224 ### ## ## ##",
        "name": "Guinea (Guinée)",
        "placeholder": "+224 000 00 00 00",
        "priority": 0
    },
    "328": {
        "areaCodes": null,
        "dialCode": "592",
        "flag": "gy",
        "iso": "GY",
        "mask": "+592 ### ####",
        "name": "Guyana",
        "placeholder": "+592 000 0000",
        "priority": 0
    },
    "332": {
        "areaCodes": null,
        "dialCode": "509",
        "flag": "ht",
        "iso": "HT",
        "mask": "+509 ## ## ####",
        "name": "Haiti",
        "placeholder": "+509 00 00 0000",
        "priority": 0
    },
    "336": {
        "areaCodes": null,
        "dialCode": "39",
        "flag": "va",
        "iso": "VA",
        "mask": "+39 ### ### ####",
        "name": "Vatican City (Città del Vaticano)",
        "placeholder": "+39 000 000 0000",
        "priority": 1
    },
    "340": {
        "areaCodes": null,
        "dialCode": "504",
        "flag": "hn",
        "iso": "HN",
        "mask": "+504 #### ####",
        "name": "Honduras",
        "placeholder": "+504 0000 0000",
        "priority": 0
    },
    "344": {
        "areaCodes": null,
        "dialCode": "852",
        "flag": "hk",
        "iso": "HK",
        "mask": "+852 #### ####",
        "name": "Hong Kong (香港)",
        "placeholder": "+852 0000 0000",
        "priority": 0
    },
    "348": {
        "areaCodes": null,
        "dialCode": "36",
        "flag": "hu",
        "iso": "HU",
        "mask": "+36 ## ### ####",
        "name": "Hungary (Magyarország)",
        "placeholder": "+36 00 000 0000",
        "priority": 0
    },
    "352": {
        "areaCodes": null,
        "dialCode": "354",
        "flag": "is",
        "iso": "IS",
        "mask": "+354 ### ####",
        "name": "Iceland (Ísland)",
        "placeholder": "+354 000 0000",
        "priority": 0
    },
    "356": {
        "areaCodes": null,
        "dialCode": "91",
        "flag": "in",
        "iso": "IN",
        "mask": "+91 ##### #####",
        "name": "India (भारत)",
        "placeholder": "+91 00000 00000",
        "priority": 0
    },
    "360": {
        "areaCodes": null,
        "dialCode": "62",
        "flag": "id",
        "iso": "ID",
        "mask": "+62 ### ### ###",
        "name": "Indonesia",
        "placeholder": "+62 000 000 000",
        "priority": 0
    },
    "364": {
        "areaCodes": null,
        "dialCode": "98",
        "flag": "ir",
        "iso": "IR",
        "mask": "+98 ### ### ####",
        "name": "Iran (‫ایران‬‎)",
        "placeholder": "+98 000 000 0000",
        "priority": 0
    },
    "368": {
        "areaCodes": null,
        "dialCode": "964",
        "flag": "iq",
        "iso": "IQ",
        "mask": "+964 ### ### ####",
        "name": "Iraq (‫العراق‬‎)",
        "placeholder": "+964 000 000 0000",
        "priority": 0
    },
    "372": {
        "areaCodes": null,
        "dialCode": "353",
        "flag": "ie",
        "iso": "IE",
        "mask": "+353 ## ### ####",
        "name": "Ireland",
        "placeholder": "+353 00 000 0000",
        "priority": 0
    },
    "380": {
        "areaCodes": null,
        "dialCode": "39",
        "flag": "it",
        "iso": "IT",
        "mask": "+39 ### ### ####",
        "name": "Italy (Italia)",
        "placeholder": "+39 000 000 0000",
        "priority": 0
    },
    "384": {
        "areaCodes": null,
        "dialCode": "225",
        "flag": "ci",
        "iso": "CI",
        "mask": "+225 ## ## ## ####",
        "name": "Côte d’Ivoire",
        "placeholder": "+225 00 00 00 0000",
        "priority": 0
    },
    "388": {
        "areaCodes": null,
        "dialCode": "1876",
        "flag": "jm",
        "iso": "JM",
        "mask": "+1876 ### ####",
        "name": "Jamaica",
        "placeholder": "+1876 000 0000",
        "priority": 0
    },
    "392": {
        "areaCodes": null,
        "dialCode": "81",
        "flag": "jp",
        "iso": "JP",
        "mask": "+81 ## #### ####",
        "name": "Japan (日本)",
        "placeholder": "+81 00 0000 0000",
        "priority": 0
    },
    "398": {
        "areaCodes": null,
        "dialCode": "7",
        "flag": "kz",
        "iso": "KZ",
        "mask": "+7 ### ### ####",
        "name": "Kazakhstan (Казахстан)",
        "placeholder": "+7 000 000 0000",
        "priority": 1
    },
    "400": {
        "areaCodes": null,
        "dialCode": "962",
        "flag": "jo",
        "iso": "JO",
        "mask": "+962 # #### ####",
        "name": "Jordan (‫الأردن‬‎)",
        "placeholder": "+962 0 0000 0000",
        "priority": 0
    },
    "404": {
        "areaCodes": null,
        "dialCode": "254",
        "flag": "ke",
        "iso": "KE",
        "mask": "+254 ### ######",
        "name": "Kenya",
        "placeholder": "+254 000 000000",
        "priority": 0
    },
    "408": {
        "areaCodes": null,
        "dialCode": "850",
        "flag": "kp",
        "iso": "KP",
        "mask": "+850 ### ### ####",
        "name": "North Korea (조선 민주주의 인민 공화국)",
        "placeholder": "+850 000 000 0000",
        "priority": 0
    },
    "410": {
        "areaCodes": null,
        "dialCode": "82",
        "flag": "kr",
        "iso": "KR",
        "mask": "+82 ## #### ####",
        "name": "South Korea (대한민국)",
        "placeholder": "+82 00 0000 0000",
        "priority": 0
    },
    "414": {
        "areaCodes": null,
        "dialCode": "965",
        "flag": "kw",
        "iso": "KW",
        "mask": "+965 ### #####",
        "name": "Kuwait (‫الكويت‬‎)",
        "placeholder": "+965 000 00000",
        "priority": 0
    },
    "417": {
        "areaCodes": null,
        "dialCode": "996",
        "flag": "kg",
        "iso": "KG",
        "mask": "+996 ### ### ###",
        "name": "Kyrgyzstan (Кыргызстан)",
        "placeholder": "+996 000 000 000",
        "priority": 0
    },
    "418": {
        "areaCodes": null,
        "dialCode": "856",
        "flag": "la",
        "iso": "LA",
        "mask": "+856 ## ## ### ###",
        "name": "Laos (ລາວ)",
        "placeholder": "+856 00 00 000 000",
        "priority": 0
    },
    "422": {
        "areaCodes": null,
        "dialCode": "961",
        "flag": "lb",
        "iso": "LB",
        "mask": "+961 ## ### ###",
        "name": "Lebanon (‫لبنان‬‎)",
        "placeholder": "+961 00 000 000",
        "priority": 0
    },
    "426": {
        "areaCodes": null,
        "dialCode": "266",
        "flag": "ls",
        "iso": "LS",
        "mask": "+266 #### ####",
        "name": "Lesotho",
        "placeholder": "+266 0000 0000",
        "priority": 0
    },
    "428": {
        "areaCodes": null,
        "dialCode": "371",
        "flag": "lv",
        "iso": "LV",
        "mask": "+371 ## ### ###",
        "name": "Latvia (Latvija)",
        "placeholder": "+371 00 000 000",
        "priority": 0
    },
    "430": {
        "areaCodes": null,
        "dialCode": "231",
        "flag": "lr",
        "iso": "LR",
        "mask": "+231 ## ### ####",
        "name": "Liberia",
        "placeholder": "+231 00 000 0000",
        "priority": 0
    },
    "434": {
        "areaCodes": null,
        "dialCode": "218",
        "flag": "ly",
        "iso": "LY",
        "mask": "+218 ## #######",
        "name": "Libya (‫ليبيا‬‎)",
        "placeholder": "+218 00 0000000",
        "priority": 0
    },
    "438": {
        "areaCodes": null,
        "dialCode": "423",
        "flag": "li",
        "iso": "LI",
        "mask": "+423 ### ### ###",
        "name": "Liechtenstein",
        "placeholder": "+423 000 000 000",
        "priority": 0
    },
    "440": {
        "areaCodes": null,
        "dialCode": "370",
        "flag": "lt",
        "iso": "LT",
        "mask": "+370 ### #####",
        "name": "Lithuania (Lietuva)",
        "placeholder": "+370 000 00000",
        "priority": 0
    },
    "442": {
        "areaCodes": null,
        "dialCode": "352",
        "flag": "lu",
        "iso": "LU",
        "mask": "+352 ### ### ###",
        "name": "Luxembourg",
        "placeholder": "+352 000 000 000",
        "priority": 0
    },
    "446": {
        "areaCodes": null,
        "dialCode": "853",
        "flag": "mo",
        "iso": "MO",
        "mask": "+853 #### ####",
        "name": "Macau (澳門)",
        "placeholder": "+853 0000 0000",
        "priority": 0
    },
    "450": {
        "areaCodes": null,
        "dialCode": "261",
        "flag": "mg",
        "iso": "MG",
        "mask": "+261 ## ## ### ##",
        "name": "Madagascar (Madagasikara)",
        "placeholder": "+261 00 00 000 00",
        "priority": 0
    },
    "454": {
        "areaCodes": null,
        "dialCode": "265",
        "flag": "mw",
        "iso": "MW",
        "mask": "+265 ### ## ## ##",
        "name": "Malawi",
        "placeholder": "+265 000 00 00 00",
        "priority": 0
    },
    "458": {
        "areaCodes": null,
        "dialCode": "60",
        "flag": "my",
        "iso": "MY",
        "mask": "+60 ## ### ####",
        "name": "Malaysia",
        "placeholder": "+60 00 000 0000",
        "priority": 0
    },
    "462": {
        "areaCodes": null,
        "dialCode": "960",
        "flag": "mv",
        "iso": "MV",
        "mask": "+960 ### ####",
        "name": "Maldives",
        "placeholder": "+960 000 0000",
        "priority": 0
    },
    "466": {
        "areaCodes": null,
        "dialCode": "223",
        "flag": "ml",
        "iso": "ML",
        "mask": "+223 ## ## ## ##",
        "name": "Mali",
        "placeholder": "+223 00 00 00 00",
        "priority": 0
    },
    "470": {
        "areaCodes": null,
        "dialCode": "356",
        "flag": "mt",
        "iso": "MT",
        "mask": "+356 #### ####",
        "name": "Malta",
        "placeholder": "+356 0000 0000",
        "priority": 0
    },
    "474": {
        "areaCodes": null,
        "dialCode": "596",
        "flag": "mq",
        "iso": "MQ",
        "mask": "+596 ### ## ## ##",
        "name": "Martinique",
        "placeholder": "+596 000 00 00 00",
        "priority": 0
    },
    "478": {
        "areaCodes": null,
        "dialCode": "222",
        "flag": "mr",
        "iso": "MR",
        "mask": "+222 ## ## ## ##",
        "name": "Mauritania (‫موريتانيا‬‎)",
        "placeholder": "+222 00 00 00 00",
        "priority": 0
    },
    "480": {
        "areaCodes": null,
        "dialCode": "230",
        "flag": "mu",
        "iso": "MU",
        "mask": "+230 #### ####",
        "name": "Mauritius (Moris)",
        "placeholder": "+230 0000 0000",
        "priority": 0
    },
    "484": {
        "areaCodes": null,
        "dialCode": "52",
        "flag": "mx",
        "iso": "MX",
        "mask": "+52 ### ### ####",
        "name": "Mexico (México)",
        "placeholder": "+52 000 000 0000",
        "priority": 0
    },
    "492": {
        "areaCodes": null,
        "dialCode": "377",
        "flag": "mc",
        "iso": "MC",
        "mask": "+377 # ## ## ## ##",
        "name": "Monaco",
        "placeholder": "+377 0 00 00 00 00",
        "priority": 0
    },
    "496": {
        "areaCodes": null,
        "dialCode": "976",
        "flag": "mn",
        "iso": "MN",
        "mask": "+976 #### ####",
        "name": "Mongolia (Монгол)",
        "placeholder": "+976 0000 0000",
        "priority": 0
    },
    "498": {
        "areaCodes": null,
        "dialCode": "373",
        "flag": "md",
        "iso": "MD",
        "mask": "+373 ### ## ###",
        "name": "Moldova (Republica Moldova)",
        "placeholder": "+373 000 00 000",
        "priority": 0
    },
    "499": {
        "areaCodes": null,
        "dialCode": "382",
        "flag": "me",
        "iso": "ME",
        "mask": "+382 ## ### ###",
        "name": "Montenegro (Crna Gora)",
        "placeholder": "+382 00 000 000",
        "priority": 0
    },
    "500": {
        "areaCodes": null,
        "dialCode": "1664",
        "flag": "ms",
        "iso": "MS",
        "mask": "+1664 ### ####",
        "name": "Montserrat",
        "placeholder": "+1664 000 0000",
        "priority": 0
    },
    "504": {
        "areaCodes": null,
        "dialCode": "212",
        "flag": "ma",
        "iso": "MA",
        "mask": "+212 ### ######",
        "name": "Morocco (‫المغرب‬‎)",
        "placeholder": "+212 000 000000",
        "priority": 0
    },
    "508": {
        "areaCodes": null,
        "dialCode": "258",
        "flag": "mz",
        "iso": "MZ",
        "mask": "+258 ## ### ####",
        "name": "Mozambique (Moçambique)",
        "placeholder": "+258 00 000 0000",
        "priority": 0
    },
    "512": {
        "areaCodes": null,
        "dialCode": "968",
        "flag": "om",
        "iso": "OM",
        "mask": "+968 #### ####",
        "name": "Oman (‫عُمان‬‎)",
        "placeholder": "+968 0000 0000",
        "priority": 0
    },
    "516": {
        "areaCodes": null,
        "dialCode": "264",
        "flag": "na",
        "iso": "NA",
        "mask": "+264 ## ### ####",
        "name": "Namibia (Namibië)",
        "placeholder": "+264 00 000 0000",
        "priority": 0
    },
    "520": {
        "areaCodes": null,
        "dialCode": "674",
        "flag": "nr",
        "iso": "NR",
        "mask": "+674 ### ####",
        "name": "Nauru",
        "placeholder": "+674 000 0000",
        "priority": 0
    },
    "524": {
        "areaCodes": null,
        "dialCode": "977",
        "flag": "np",
        "iso": "NP",
        "mask": "+977 ### #######",
        "name": "Nepal (नेपाल)",
        "placeholder": "+977 000 0000000",
        "priority": 0
    },
    "528": {
        "areaCodes": null,
        "dialCode": "31",
        "flag": "nl",
        "iso": "NL",
        "mask": "+31 # ########",
        "name": "Netherlands (Nederland)",
        "placeholder": "+31 0 00000000",
        "priority": 0
    },
    "531": {
        "areaCodes": null,
        "dialCode": "599",
        "flag": "cw",
        "iso": "CW",
        "mask": "+599 # ### ####",
        "name": "Curaçao",
        "placeholder": "+599 0 000 0000",
        "priority": 0
    },
    "533": {
        "areaCodes": null,
        "dialCode": "297",
        "flag": "aw",
        "iso": "AW",
        "mask": "+297 ### ####",
        "name": "Aruba",
        "placeholder": "+297 000 0000",
        "priority": 0
    },
    "540": {
        "areaCodes": null,
        "dialCode": "687",
        "flag": "nc",
        "iso": "NC",
        "mask": "+687 ## ## ##",
        "name": "New Caledonia (Nouvelle-Calédonie)",
        "placeholder": "+687 00 00 00",
        "priority": 0
    },
    "544": {
        "areaCodes": null,
        "dialCode": "387",
        "flag": "ba",
        "iso": "BA",
        "mask": "+387 ## ### ###",
        "name": "Bosnia and Herzegovina (Босна и Херцеговина)",
        "placeholder": "+387 00 000 000",
        "priority": 0
    },
    "548": {
        "areaCodes": null,
        "dialCode": "678",
        "flag": "vu",
        "iso": "VU",
        "mask": "+678 ### ####",
        "name": "Vanuatu",
        "placeholder": "+678 000 0000",
        "priority": 0
    },
    "554": {
        "areaCodes": null,
        "dialCode": "64",
        "flag": "nz",
        "iso": "NZ",
        "mask": "+64 ## ### ####",
        "name": "New Zealand",
        "placeholder": "+64 00 000 0000",
        "priority": 0
    },
    "558": {
        "areaCodes": null,
        "dialCode": "505",
        "flag": "ni",
        "iso": "NI",
        "mask": "+505 #### ####",
        "name": "Nicaragua",
        "placeholder": "+505 0000 0000",
        "priority": 0
    },
    "562": {
        "areaCodes": null,
        "dialCode": "227",
        "flag": "ne",
        "iso": "NE",
        "mask": "+227 ## ## ## ##",
        "name": "Niger (Nijar)",
        "placeholder": "+227 00 00 00 00",
        "priority": 0
    },
    "566": {
        "areaCodes": null,
        "dialCode": "234",
        "flag": "ng",
        "iso": "NG",
        "mask": "+234 ### ### ####",
        "name": "Nigeria",
        "placeholder": "+234 000 000 0000",
        "priority": 0
    },
    "570": {
        "areaCodes": null,
        "dialCode": "683",
        "flag": "nu",
        "iso": "NU",
        "mask": "+683 ### ####",
        "name": "Niue",
        "placeholder": "+683 000 0000",
        "priority": 0
    },
    "574": {
        "areaCodes": null,
        "dialCode": "672",
        "flag": "nf",
        "iso": "NF",
        "mask": "+672 # #####",
        "name": "Norfolk Island",
        "placeholder": "+672 0 00000",
        "priority": 0
    },
    "578": {
        "areaCodes": null,
        "dialCode": "47",
        "flag": "no",
        "iso": "NO",
        "mask": "+47 ### ## ###",
        "name": "Norway (Norge)",
        "placeholder": "+47 000 00 000",
        "priority": 0
    },
    "580": {
        "areaCodes": null,
        "dialCode": "1670",
        "flag": "mp",
        "iso": "MP",
        "mask": "+1670 ### ####",
        "name": "Northern Mariana Islands",
        "placeholder": "+1670 000 0000",
        "priority": 0
    },
    "583": {
        "areaCodes": null,
        "dialCode": "691",
        "flag": "fm",
        "iso": "FM",
        "mask": "+691 ### ####",
        "name": "Micronesia",
        "placeholder": "+691 000 0000",
        "priority": 0
    },
    "584": {
        "areaCodes": null,
        "dialCode": "692",
        "flag": "mh",
        "iso": "MH",
        "mask": "+692 ### ####",
        "name": "Marshall Islands",
        "placeholder": "+692 000 0000",
        "priority": 0
    },
    "585": {
        "areaCodes": null,
        "dialCode": "680",
        "flag": "pw",
        "iso": "PW",
        "mask": "+680 ### ####",
        "name": "Palau",
        "placeholder": "+680 000 0000",
        "priority": 0
    },
    "586": {
        "areaCodes": null,
        "dialCode": "92",
        "flag": "pk",
        "iso": "PK",
        "mask": "+92 ### #######",
        "name": "Pakistan (‫پاکستان‬‎)",
        "placeholder": "+92 000 0000000",
        "priority": 0
    },
    "590": {
        "areaCodes": null,
        "dialCode": "507",
        "flag": "pa",
        "iso": "PA",
        "mask": "+507 #### ####",
        "name": "Panama (Panamá)",
        "placeholder": "+507 0000 0000",
        "priority": 0
    },
    "598": {
        "areaCodes": null,
        "dialCode": "675",
        "flag": "pg",
        "iso": "PG",
        "mask": "+675 #### ####",
        "name": "Papua New Guinea",
        "placeholder": "+675 0000 0000",
        "priority": 0
    },
    "600": {
        "areaCodes": null,
        "dialCode": "595",
        "flag": "py",
        "iso": "PY",
        "mask": "+595 ### ######",
        "name": "Paraguay",
        "placeholder": "+595 000 000000",
        "priority": 0
    },
    "604": {
        "areaCodes": null,
        "dialCode": "51",
        "flag": "pe",
        "iso": "PE",
        "mask": "+51 ### ### ###",
        "name": "Peru (Perú)",
        "placeholder": "+51 000 000 000",
        "priority": 0
    },
    "608": {
        "areaCodes": null,
        "dialCode": "63",
        "flag": "ph",
        "iso": "PH",
        "mask": "+63 ### ### ####",
        "name": "Philippines",
        "placeholder": "+63 000 000 0000",
        "priority": 0
    },
    "616": {
        "areaCodes": null,
        "dialCode": "48",
        "flag": "pl",
        "iso": "PL",
        "mask": "+48 ### ### ###",
        "name": "Poland (Polska)",
        "placeholder": "+48 000 000 000",
        "priority": 0
    },
    "620": {
        "areaCodes": null,
        "dialCode": "351",
        "flag": "pt",
        "iso": "PT",
        "mask": "+351 ### ### ###",
        "name": "Portugal",
        "placeholder": "+351 000 000 000",
        "priority": 0
    },
    "624": {
        "areaCodes": null,
        "dialCode": "245",
        "flag": "gw",
        "iso": "GW",
        "mask": "+245 ### ### ###",
        "name": "Guinea-Bissau (Guiné Bissau)",
        "placeholder": "+245 000 000 000",
        "priority": 0
    },
    "626": {
        "areaCodes": null,
        "dialCode": "670",
        "flag": "tl",
        "iso": "TL",
        "mask": "+670 #### ####",
        "name": "Timor-Leste",
        "placeholder": "+670 0000 0000",
        "priority": 0
    },
    "630": {
        "areaCodes": [
            "787",
            "939"
        ],
        "dialCode": "1",
        "flag": "pr",
        "iso": "PR",
        "mask": "+1 ### ### ####",
        "name": "Puerto Rico",
        "placeholder": "+1 000 000 0000",
        "priority": 3
    },
    "634": {
        "areaCodes": null,
        "dialCode": "974",
        "flag": "qa",
        "iso": "QA",
        "mask": "+974 #### ####",
        "name": "Qatar (‫قطر‬‎)",
        "placeholder": "+974 0000 0000",
        "priority": 0
    },
    "642": {
        "areaCodes": null,
        "dialCode": "40",
        "flag": "ro",
        "iso": "RO",
        "mask": "+40 ### ### ###",
        "name": "Romania (România)",
        "placeholder": "+40 000 000 000",
        "priority": 0
    },
    "643": {
        "areaCodes": null,
        "dialCode": "7",
        "flag": "ru",
        "iso": "RU",
        "mask": "+7 ### ### ## ##",
        "name": "Russia (Россия)",
        "placeholder": "+7 000 000 00 00",
        "priority": 0
    },
    "646": {
        "areaCodes": null,
        "dialCode": "250",
        "flag": "rw",
        "iso": "RW",
        "mask": "+250 ### ### ###",
        "name": "Rwanda",
        "placeholder": "+250 000 000 000",
        "priority": 0
    },
    "652": {
        "areaCodes": null,
        "dialCode": "590",
        "flag": "bl",
        "iso": "BL",
        "mask": "+590 ### ## ## ##",
        "name": "Saint Barthélemy",
        "placeholder": "+590 000 00 00 00",
        "priority": 1
    },
    "654": {
        "areaCodes": null,
        "dialCode": "290",
        "flag": "sh",
        "iso": "SH",
        "mask": "+290 #####",
        "name": "Saint Helena",
        "placeholder": "+290 00000",
        "priority": 0
    },
    "659": {
        "areaCodes": null,
        "dialCode": "1869",
        "flag": "kn",
        "iso": "KN",
        "mask": "+1869 ### ####",
        "name": "Saint Kitts and Nevis",
        "placeholder": "+1869 000 0000",
        "priority": 0
    },
    "660": {
        "areaCodes": null,
        "dialCode": "1264",
        "flag": "ai",
        "iso": "AI",
        "mask": "+1264 ### ####",
        "name": "Anguilla",
        "placeholder": "+1264 000 0000",
        "priority": 0
    },
    "662": {
        "areaCodes": null,
        "dialCode": "1758",
        "flag": "lc",
        "iso": "LC",
        "mask": "+1758 ### ####",
        "name": "Saint Lucia",
        "placeholder": "+1758 000 0000",
        "priority": 0
    },
    "663": {
        "areaCodes": null,
        "dialCode": "590",
        "flag": "mf",
        "iso": "MF",
        "mask": "+590 ### ## ## ##",
        "name": "Saint Martin (Saint-Martin (partie française))",
        "placeholder": "+590 000 00 00 00",
        "priority": 2
    },
    "666": {
        "areaCodes": null,
        "dialCode": "508",
        "flag": "pm",
        "iso": "PM",
        "mask": "+508 ## ## ##",
        "name": "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
        "placeholder": "+508 00 00 00",
        "priority": 0
    },
    "670": {
        "areaCodes": null,
        "dialCode": "1784",
        "flag": "vc",
        "iso": "VC",
        "mask": "+1784 ### ####",
        "name": "Saint Vincent and the Grenadines",
        "placeholder": "+1784 000 0000",
        "priority": 0
    },
    "674": {
        "areaCodes": null,
        "dialCode": "378",
        "flag": "sm",
        "iso": "SM",
        "mask": "+378 ## ## ## ##",
        "name": "San Marino",
        "placeholder": "+378 00 00 00 00",
        "priority": 0
    },
    "682": {
        "areaCodes": null,
        "dialCode": "966",
        "flag": "sa",
        "iso": "SA",
        "mask": "+966 ## ### ####",
        "name": "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
        "placeholder": "+966 00 000 0000",
        "priority": 0
    },
    "686": {
        "areaCodes": null,
        "dialCode": "221",
        "flag": "sn",
        "iso": "SN",
        "mask": "+221 ## ### ## ##",
        "name": "Senegal (Sénégal)",
        "placeholder": "+221 00 000 00 00",
        "priority": 0
    },
    "688": {
        "areaCodes": null,
        "dialCode": "381",
        "flag": "rs",
        "iso": "RS",
        "mask": "+381 ## #######",
        "name": "Serbia (Србија)",
        "placeholder": "+381 00 0000000",
        "priority": 0
    },
    "690": {
        "areaCodes": null,
        "dialCode": "248",
        "flag": "sc",
        "iso": "SC",
        "mask": "+248 # ### ###",
        "name": "Seychelles",
        "placeholder": "+248 0 000 000",
        "priority": 0
    },
    "694": {
        "areaCodes": null,
        "dialCode": "232",
        "flag": "sl",
        "iso": "SL",
        "mask": "+232 ## ######",
        "name": "Sierra Leone",
        "placeholder": "+232 00 000000",
        "priority": 0
    },
    "702": {
        "areaCodes": null,
        "dialCode": "65",
        "flag": "sg",
        "iso": "SG",
        "mask": "+65 #### ####",
        "name": "Singapore",
        "placeholder": "+65 0000 0000",
        "priority": 0
    },
    "703": {
        "areaCodes": null,
        "dialCode": "421",
        "flag": "sk",
        "iso": "SK",
        "mask": "+421 ### ### ###",
        "name": "Slovakia (Slovensko)",
        "placeholder": "+421 000 000 000",
        "priority": 0
    },
    "704": {
        "areaCodes": null,
        "dialCode": "84",
        "flag": "vn",
        "iso": "VN",
        "mask": "+84 ## ### ## ##",
        "name": "Vietnam (Việt Nam)",
        "placeholder": "+84 00 000 00 00",
        "priority": 0
    },
    "705": {
        "areaCodes": null,
        "dialCode": "386",
        "flag": "si",
        "iso": "SI",
        "mask": "+386 ## ######",
        "name": "Slovenia (Slovenija)",
        "placeholder": "+386 00 000000",
        "priority": 0
    },
    "706": {
        "areaCodes": null,
        "dialCode": "252",
        "flag": "so",
        "iso": "SO",
        "mask": "+252 # #######",
        "name": "Somalia (Soomaaliya)",
        "placeholder": "+252 0 0000000",
        "priority": 0
    },
    "710": {
        "areaCodes": null,
        "dialCode": "27",
        "flag": "za",
        "iso": "ZA",
        "mask": "+27 ## ### ####",
        "name": "South Africa",
        "placeholder": "+27 00 000 0000",
        "priority": 0
    },
    "716": {
        "areaCodes": null,
        "dialCode": "263",
        "flag": "zw",
        "iso": "ZW",
        "mask": "+263 ## ### ####",
        "name": "Zimbabwe",
        "placeholder": "+263 00 000 0000",
        "priority": 0
    },
    "724": {
        "areaCodes": null,
        "dialCode": "34",
        "flag": "es",
        "iso": "ES",
        "mask": "+34 ### ## ## ##",
        "name": "Spain (España)",
        "placeholder": "+34 000 00 00 00",
        "priority": 0
    },
    "728": {
        "areaCodes": null,
        "dialCode": "211",
        "flag": "ss",
        "iso": "SS",
        "mask": "+211 ### ### ###",
        "name": "South Sudan (‫جنوب السودان‬‎)",
        "placeholder": "+211 000 000 000",
        "priority": 0
    },
    "732": {
        "areaCodes": null,
        "dialCode": "212",
        "flag": "eh",
        "iso": "EH",
        "mask": "+212 ### ######",
        "name": "Western Sahara (‫الصحراء الغربية‬‎)",
        "placeholder": "+212 000 000000",
        "priority": 1
    },
    "736": {
        "areaCodes": null,
        "dialCode": "249",
        "flag": "sd",
        "iso": "SD",
        "mask": "+249 ## ### ####",
        "name": "Sudan (‫السودان‬‎)",
        "placeholder": "+249 00 000 0000",
        "priority": 0
    },
    "740": {
        "areaCodes": null,
        "dialCode": "597",
        "flag": "sr",
        "iso": "SR",
        "mask": "+597 ### ####",
        "name": "Suriname",
        "placeholder": "+597 000 0000",
        "priority": 0
    },
    "744": {
        "areaCodes": null,
        "dialCode": "47",
        "flag": "sj",
        "iso": "SJ",
        "mask": "+47 ### ## ###",
        "name": "Svalbard and Jan Mayen",
        "placeholder": "+47 000 00 000",
        "priority": 1
    },
    "748": {
        "areaCodes": null,
        "dialCode": "268",
        "flag": "sz",
        "iso": "SZ",
        "mask": "+268 #### ####",
        "name": "Swaziland",
        "placeholder": "+268 0000 0000",
        "priority": 0
    },
    "752": {
        "areaCodes": null,
        "dialCode": "46",
        "flag": "se",
        "iso": "SE",
        "mask": "+46 ## ### ## ##",
        "name": "Sweden (Sverige)",
        "placeholder": "+46 00 000 00 00",
        "priority": 0
    },
    "756": {
        "areaCodes": null,
        "dialCode": "41",
        "flag": "ch",
        "iso": "CH",
        "mask": "+41 ## ### ## ##",
        "name": "Switzerland (Schweiz)",
        "placeholder": "+41 00 000 00 00",
        "priority": 0
    },
    "760": {
        "areaCodes": null,
        "dialCode": "963",
        "flag": "sy",
        "iso": "SY",
        "mask": "+963 ### ### ###",
        "name": "Syria (‫سوريا‬‎)",
        "placeholder": "+963 000 000 000",
        "priority": 0
    },
    "762": {
        "areaCodes": null,
        "dialCode": "992",
        "flag": "tj",
        "iso": "TJ",
        "mask": "+992 ### ## ####",
        "name": "Tajikistan",
        "placeholder": "+992 000 00 0000",
        "priority": 0
    },
    "764": {
        "areaCodes": null,
        "dialCode": "66",
        "flag": "th",
        "iso": "TH",
        "mask": "+66 ## ### ####",
        "name": "Thailand (ไทย)",
        "placeholder": "+66 00 000 0000",
        "priority": 0
    },
    "768": {
        "areaCodes": null,
        "dialCode": "228",
        "flag": "tg",
        "iso": "TG",
        "mask": "+228 ## ## ## ##",
        "name": "Togo",
        "placeholder": "+228 00 00 00 00",
        "priority": 0
    },
    "772": {
        "areaCodes": null,
        "dialCode": "690",
        "flag": "tk",
        "iso": "TK",
        "mask": "+690 ####",
        "name": "Tokelau",
        "placeholder": "+690 0000",
        "priority": 0
    },
    "776": {
        "areaCodes": null,
        "dialCode": "676",
        "flag": "to",
        "iso": "TO",
        "mask": "+676 ### ####",
        "name": "Tonga",
        "placeholder": "+676 000 0000",
        "priority": 0
    },
    "780": {
        "areaCodes": null,
        "dialCode": "1868",
        "flag": "tt",
        "iso": "TT",
        "mask": "+1868 ### ####",
        "name": "Trinidad and Tobago",
        "placeholder": "+1868 000 0000",
        "priority": 0
    },
    "784": {
        "areaCodes": null,
        "dialCode": "971",
        "flag": "ae",
        "iso": "AE",
        "mask": "+971 ## ### ####",
        "name": "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
        "placeholder": "+971 00 000 0000",
        "priority": 0
    },
    "788": {
        "areaCodes": null,
        "dialCode": "216",
        "flag": "tn",
        "iso": "TN",
        "mask": "+216 ## ### ###",
        "name": "Tunisia (‫تونس‬‎)",
        "placeholder": "+216 00 000 000",
        "priority": 0
    },
    "792": {
        "areaCodes": null,
        "dialCode": "90",
        "flag": "tr",
        "iso": "TR",
        "mask": "+90 ### ### ## ##",
        "name": "Turkey (Türkiye)",
        "placeholder": "+90 000 000 00 00",
        "priority": 0
    },
    "795": {
        "areaCodes": null,
        "dialCode": "993",
        "flag": "tm",
        "iso": "TM",
        "mask": "+993 ## ######",
        "name": "Turkmenistan",
        "placeholder": "+993 00 000000",
        "priority": 0
    },
    "796": {
        "areaCodes": null,
        "dialCode": "1649",
        "flag": "tc",
        "iso": "TC",
        "mask": "+1649 ### ####",
        "name": "Turks and Caicos Islands",
        "placeholder": "+1649 000 0000",
        "priority": 0
    },
    "798": {
        "areaCodes": null,
        "dialCode": "688",
        "flag": "tv",
        "iso": "TV",
        "mask": "+688 ## ####",
        "name": "Tuvalu",
        "placeholder": "+688 00 0000",
        "priority": 0
    },
    "800": {
        "areaCodes": null,
        "dialCode": "256",
        "flag": "ug",
        "iso": "UG",
        "mask": "+256 ### ######",
        "name": "Uganda",
        "placeholder": "+256 000 000000",
        "priority": 0
    },
    "804": {
        "areaCodes": null,
        "dialCode": "380",
        "flag": "ua",
        "iso": "UA",
        "mask": "+380 ## ### ####",
        "name": "Ukraine (Україна)",
        "placeholder": "+380 00 000 0000",
        "priority": 0
    },
    "807": {
        "areaCodes": null,
        "dialCode": "389",
        "flag": "mk",
        "iso": "MK",
        "mask": "+389 ## ### ###",
        "name": "Macedonia (FYROM) (Македонија)",
        "placeholder": "+389 00 000 000",
        "priority": 0
    },
    "810": {
        "areaCodes": null,
        "dialCode": "7",
        "flag": "ru",
        "iso": "RU",
        "mask": "+7 ### ### ## ##",
        "name": "Russia (Россия)",
        "placeholder": "+7 000 000 00 00",
        "priority": 0
    },
    "818": {
        "areaCodes": null,
        "dialCode": "20",
        "flag": "eg",
        "iso": "EG",
        "mask": "+20 ### ### ####",
        "name": "Egypt (‫مصر‬‎)",
        "placeholder": "+20 000 000 0000",
        "priority": 0
    },
    "826": {
        "areaCodes": null,
        "dialCode": "44",
        "flag": "uk",
        "iso": "UK",
        "mask": "+44 #### ######",
        "name": "United Kingdom",
        "placeholder": "+44 0000 000000",
        "priority": 0
    },
    "831": {
        "areaCodes": null,
        "dialCode": "44",
        "flag": "gg",
        "iso": "GG",
        "mask": "+44 #### ######",
        "name": "Guernsey",
        "placeholder": "+44 0000 000000",
        "priority": 1
    },
    "832": {
        "areaCodes": null,
        "dialCode": "44",
        "flag": "je",
        "iso": "JE",
        "mask": "+44 #### ######",
        "name": "Jersey",
        "placeholder": "+44 0000 000000",
        "priority": 3
    },
    "833": {
        "areaCodes": null,
        "dialCode": "44",
        "flag": "im",
        "iso": "IM",
        "mask": "+44 #### ######",
        "name": "Isle of Man",
        "placeholder": "+44 0000 000000",
        "priority": 2
    },
    "834": {
        "areaCodes": null,
        "dialCode": "255",
        "flag": "tz",
        "iso": "TZ",
        "mask": "+255 ### ### ###",
        "name": "Tanzania",
        "placeholder": "+255 000 000 000",
        "priority": 0
    },
    "840": {
        "areaCodes": null,
        "dialCode": "1",
        "flag": "us",
        "iso": "US",
        "mask": "+1 ### ### ####",
        "name": "United States",
        "placeholder": "+1 000 000 0000",
        "priority": 0
    },
    "850": {
        "areaCodes": null,
        "dialCode": "1340",
        "flag": "vi",
        "iso": "VI",
        "mask": "+1340 ### ####",
        "name": "U.S. Virgin Islands",
        "placeholder": "+1340 000 0000",
        "priority": 0
    },
    "854": {
        "areaCodes": null,
        "dialCode": "226",
        "flag": "bf",
        "iso": "BF",
        "mask": "+226 ## ## ## ##",
        "name": "Burkina Faso",
        "placeholder": "+226 00 00 00 00",
        "priority": 0
    },
    "858": {
        "areaCodes": null,
        "dialCode": "598",
        "flag": "uy",
        "iso": "UY",
        "mask": "+598 ## ### ###",
        "name": "Uruguay",
        "placeholder": "+598 00 000 000",
        "priority": 0
    },
    "860": {
        "areaCodes": null,
        "dialCode": "998",
        "flag": "uz",
        "iso": "UZ",
        "mask": "+998 ## ### ## ##",
        "name": "Uzbekistan (Oʻzbekiston)",
        "placeholder": "+998 00 000 00 00",
        "priority": 0
    },
    "862": {
        "areaCodes": null,
        "dialCode": "58",
        "flag": "ve",
        "iso": "VE",
        "mask": "+58 ### #######",
        "name": "Venezuela",
        "placeholder": "+58 000 0000000",
        "priority": 0
    },
    "876": {
        "areaCodes": null,
        "dialCode": "681",
        "flag": "wf",
        "iso": "WF",
        "mask": "+681 ## ## ##",
        "name": "Wallis and Futuna (Wallis-et-Futuna)",
        "placeholder": "+681 00 00 00",
        "priority": 0
    },
    "882": {
        "areaCodes": null,
        "dialCode": "685",
        "flag": "ws",
        "iso": "WS",
        "mask": "+685 ## #####",
        "name": "Samoa",
        "placeholder": "+685 00 00000",
        "priority": 0
    },
    "886": {
        "areaCodes": null,
        "dialCode": "967",
        "flag": "ye",
        "iso": "YE",
        "mask": "+967 ### ### ###",
        "name": "Yemen (‫اليمن‬‎)",
        "placeholder": "+967 000 000 000",
        "priority": 0
    },
    "894": {
        "areaCodes": null,
        "dialCode": "260",
        "flag": "zm",
        "iso": "ZM",
        "mask": "+260 ## #######",
        "name": "Zambia",
        "placeholder": "+260 00 0000000",
        "priority": 0
    },
    "901": {
        "areaCodes": null,
        "dialCode": "886",
        "flag": "tw",
        "iso": "TW",
        "mask": "+886 ### ### ###",
        "name": "Taiwan (台灣)",
        "placeholder": "+886 000 000 000",
        "priority": 0
    },
    "990": {
        "areaCodes": null,
        "flag": "passport",
        "priority": 0
    },
    "991": {
        "areaCodes": null,
        "dialCode": "383",
        "flag": "xk",
        "iso": "XK",
        "mask": "+383 ## ### ###",
        "name": "Kosovo",
        "placeholder": "+383 00 000 000",
        "priority": 0
    },
    "992": {
        "areaCodes": null,
        "flag": "passport_eng",
        "priority": 0
    },
    "999": {
        "areaCodes": null,
        "dialCode": "970",
        "flag": "ps",
        "iso": "PS",
        "mask": "+970 ### ### ###",
        "name": "Palestine (‫فلسطين‬‎)",
        "placeholder": "+970 000 000 000",
        "priority": 0
    }
}
